<template>
  <div :class="{ [$style.compact]: compact, [$style.open]: open }">
    <button type="button" :class="[headClass, $style.head]" @click="open = !open">
      <h3 :class="[$style.title]">
        {{ title }}
      </h3>
      <slot name="head" />
      <SvgIcon width="18" height="18" src="icon-sprite.svg#arrow" />
    </button>

    <AutoHeight :wrapper-class="$style.body" :open="open">
      <slot />
    </AutoHeight>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import AutoHeight from './AutoHeight.vue';
import SvgIcon from './SvgIcon.vue';

export default defineComponent({
  components: { AutoHeight, SvgIcon },
  props: {
    startOpen: { type: Boolean, default: true },
    headClass: { type: String, default: '' },
    title: { type: String, default: '—' },
    compact: { type: Boolean, default: false },
  },
  data() {
    return {
      open: this.startOpen,
    };
  },
});
</script>

<style lang="scss" src="./common.module.scss" module="com"></style>
<style lang="scss" module>
.head {
  width: 100%;

  background: var(--table-head-color);
  border: 1px solid var(--accordeon-border-color);
  border-radius: 2px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 10px 7px 20px;

  svg {
    @media print {
      display: none;
    }
  }

  &:hover {
    background: var(--table-head-color-hover);
    border-color: var(--accordeon-border-color-hover);
  }
}
.title {
  font-weight: 500;
  font-size: 16px;
  letter-spacing: 0.02em;
  color: #3f4757;
}
.body {
  background: rgba(239, 243, 246, 0.3);
  border: 1px solid var(--table-border-color);
  border-radius: 0 0 6px 6px;
  border-top: none;
  @media print {
    display: block !important;
  }
}
.open {
  .head {
    border-radius: 2px 2px 0 0;

    svg {
      transform: scaleY(-1);
    }
  }
}

.compact {
  .head {
    background: var(--secondary-cell-color);
    border: 1px solid #dce5ed;
    padding: 4px 7px 4px 9px;
    border-radius: 1px 1px 0 0;
    @media print {
      background: #e9e9e9;
    }
  }
  .body {
    border-radius: 0 0 1px 1px;
  }

  .title {
    font-size: 12px;
  }
}
</style>
